<script>
import {Listeners} from "keysso/constants/listeners";
import WordstatApi from "keysso/api/WordstatApi";
import {DataTransformer} from "../DataTransformer";
import {ProjectsConstants} from "../constants/projectConstants";
import WordstatBaseUpdate from "./BaseUpdate.vue";

/**
 * Обновление отдельных фраз проекта через чекбоксы таблицы
 */
export default {
    name: "WordstatUpdateWords",
    extends: WordstatBaseUpdate,
    methods: {
        getListenerId() {
            return Listeners.WORDSTAT_POPUP_UPDATE_WORDS_OPEN;
        },
        update() {
            this.loading = true;
            const payload = DataTransformer.payloadUpdateWords({
                words: this.model.words,
                frequency: this.model.frequency,
                parsingType: ProjectsConstants.PARSING_TYPE_WS,
                parse_budget_cpc: this.model.parse_budget_cpc,
            });
            WordstatApi
                .updateWords(this.model.id, payload)
                .then(() => location.reload())
                .catch(error => this.alertError(error.message))
                .finally(() => this.loading = false);
        },
    }
}
</script>
